// extracted by mini-css-extract-plugin
export default {"card":"StepSuccessCard_card__p8S4j","text":"StepSuccessCard_text__z0oMR"};